export { default as GenericCreate } from './genericCreate';
export { default as GenericList } from './genericList';
export { default as GenericEdit } from './genericEdit';
export { default as GenericShow } from './genericShow';
export { default as GenericPossibleMatchView } from './genericPossibleMatchView';
export { default as GenericSpecificMatchView } from './genericSpecificMatchView';
export * from './utils/genericUtils';
